<template>
  <div class="container-fluid pt-2 px-0" style="background-color:white;">
    <saiten-edit-tab :tab-no="tabNo" :sheet="sheet"/>
    <div class="row mx-0 mb-2" style="background-color:#1e90bd; height:45px;">
      <div class="col d-flex align-items-center">
        <font-awesome-icon icon="arrow-circle-left" class="icon-history-back" size="2x" @click="$store.dispatch('goSheetList')"/>
        <h6 class="header-tab-sheet-info mr-3 mb-0">中学入試</h6>
        <h6 class="header-tab-sheet-info">{{sheet.name}}</h6>
        <h6 class="header-tab-sheet-info">{{$store.getters.getCurriculumNameById(sheet.curriculum_id)}}</h6>
      </div>
    </div>
    <div v-if="sheet.field_names_completed" class="container-fluid pt-2 px-0" style="background-color:white;">
      <alert-area :errors="errors" v-on:close="errors = []"/>
      <div class="text-right my-2 mx-3">
        <span>テンプレートファイルは</span>
        <a href="javascript:void(0);" @click="downloadFieldTemplate()">コチラ</a>
        <span>から</span>
      </div>
      <drop-area text-html="大問構造を記入したエクセルファイルをドラッグ&ドロップしてください" 
                :extensions="['xlsx']"
                v-on:drop-success="upload"
                v-on:drop-error="errors.push($event)"/>
      <div v-if="sheet.part1_names_completed" class="row m-0 py-2">
        <div class="col text-right">
          <b-button variant="primary" @click="saveClick()">保存</b-button>
        </div>
      </div>
      <div v-if="sheet.part1_names_completed" class="container">
        <div class="row p-2">
          <div class="col">
            <table id="sheet-list-table" class="table table-bordered text-center">
              <thead class="thead-dark">
                <tr>
                  <th>NO</th>
                  <th>大問</th>
                  <th>大問内容</th>
                </tr>
              </thead>
              <tbody>
                  <tr v-for="(part1Mst, idx) in part1Msts" :key="idx" v-bind:style="idx % 2 == 1 ? {'background-color': '#f2f2f2'} : {}">
                    <td>{{idx + 1}}</td>
                    <td><b-input v-model="part1Mst.part1"/></td>
                    <td><b-input v-model="part1Mst.content"/></td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container-fluid pt-2 px-0" style="background-color:white;">
      <b-alert v-if="sheet.field_names_completed != undefined" variant="info" :show="true" class="mx-2">
      <h5>配点Excelの登録が未完了です。</h5>
    </b-alert>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab";
import DropArea from "../../components/DropArea";
import AlertArea from "../../components/AlertArea";

export default Vue.extend({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  data(){
    return {
      tabNo: 5,
      sheet_group_key: null,
      sheet: {},
      part1Msts: [],
      errors: [],
      SheetTypeEnum: Common.SheetTypeEnum,
    };
  },
  async created(){

    this.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
    this.sheet_group_key = this.$route.params.sheet_group_key;

    // APIで登録済み試験情報取得
    await http.get(`/api/teacher/practice_part1_edit?sheet_group_key=${this.sheet_group_key}`).then(response => {
      this.sheet = response.data.sheet;
      this.part1Msts = response.data.part1_msts;
    })
    .catch(error=>{
      // 後続処理不能のため一覧に戻る
      if(error.response.status == 422){
        alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
      }else{
        alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
      }
      this.$store.dispatch("goSheetList");
    });

    this.$store.dispatch("hideOverlay");
  },
  mounted() {
    this.$store.commit("setIsHeaderDisp", false);
  },
  beforeDestroy() {
    this.$store.commit("setIsHeaderDisp", true);
  },
  methods: {
    async downloadFieldTemplate(){
      await http.get(`/api/teacher/practice_part1_edit/download_field_template/${this.sheet_group_key}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `practice_part1_template.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          this.errors = errorData.errors;
        }else{
          this.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    },
    // ファイルアップロード
    async upload(file){      
      
      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      this.$store.dispatch("showOverlay", "ファイル読み込み中");

      await http.post(`/api/teacher/practice_part1_edit/upload/${this.sheet_group_key}`, fd).then(response => {
        this.sheet = response.data.sheet;
        this.part1Msts = response.data.part1_msts;

        alert("アップロードが完了しました。");
        this.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          this.errors = error.response.data.errors;
        }else{
          this.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      this.$store.dispatch("hideOverlay");
    },
    // 保存ボタンクリック
    async saveClick(){

      if(!window.confirm("大問構造を保存します。よろしいですか？")){
        return;
      }

      this.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/practice_part1_edit/update/${this.sheet_group_key}`, {part1_msts: this.part1Msts}).then(response => {
        alert("処理が完了しました。");
        this.$router.push(`/teacher_site/correct_image_upload/${this.sheet_group_key}`).catch(err => {});
      })
      .catch(error=>{
        if(error.response.status == 422){
          this.errors = error.response.data.errors;
        }else{
          this.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      this.$store.dispatch("hideOverlay");
    }
  }
})
</script>



